import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { PlayerHomeActions } from 'src/redux/player-home';
import { ContentType } from 'src/remote-request';
import {
  NavParams,
  ToastController,
  Platform,
  ModalController,
  AlertController,
  LoadingController,
  ActionSheetController,
} from '@ionic/angular';
import { CourseInfo, CourseHoleInfo, ClubInfo } from 'src/data/club-course';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import {
  BookingPlayerType,
  ClubCourseData,
  ClubData,
  Country,
  DiscountCompany,
  DiscountCompanyProgram,
  DiscountPlayerClub,
  PlayerBookingTypeAssociation,
  PlayerDiscountProgram,
  PlayerInsurance,
  TeeTimeBooking,
  TeeTimeSlotDisplay,
} from 'src/data/mygolf.data';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerInfo } from 'src/data/player-data';
import { ImageService } from 'src/providers/image-service/image-service';
import * as moment from 'moment';
import { SearchDiscountCompanyPage } from '../search-discount-company/search-discount-company.page';
import { ProgramClubListPage } from '../program-club-list/program-club-list.page';
import { JsonService } from 'src/json-util';
import { ImageZoomPage } from '../../image-zoom/image-zoom.page';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerData } from 'src/data/mygolf.data';
import { AddPlayerListPage } from '../../add-player-list/add-player-list.page';

@Component({
  selector: 'app-add-player-type-discount',
  templateUrl: './add-player-type-discount.page.html',
  styleUrls: ['./add-player-type-discount.page.scss'],
})
export class AddPlayerTypeDiscountPage implements OnInit {
  @ViewChild('selectDealImage') selectDealImage: ElementRef;
  courses: Array<CourseInfo>;
  clubId: number;
  forDate: string;
  isClub: boolean = false;
  courseId: number;
  teeSlot: Array<TeeTimeSlotDisplay>;
  startCourses: Array<ClubCourseData>;
  changeType: string;
  currentSlot: TeeTimeBooking;
  color: string;
  currentTime: string;
  mode: string = 'view';
  type: string;
  optionTypes: string = 'details';
  headerTitle: string;
  playerTypes: Array<any>;
  discountCards: Array<any>;
  discountCompanies: Array<DiscountCompany>;
  selectedDiscountCompany: DiscountCompany;
  cardMembershipNo: string;
  discountPrograms: Array<DiscountCompanyProgram>;
  selectedDiscountProgram: any;

  cardValidFrom: string;
  cardValidUntil: string;
  @Input() player: any; //PlayerInfo | PlayerData;
  cardMaxDate: string;
  selectOrNewPlayer: string = 'new';
  addPlayerDetails = {
    email: '',
    playerName: '',
    password: '',
    phoneNumber: '',
    gender: 'M',
  };
  forBooking: boolean = false;
  fromClub: boolean = false;
  playerDiscountProgram: PlayerDiscountProgram;
  pendingPDP: Array<DiscountPlayerClub> = new Array<DiscountPlayerClub>();
  temporaryImageURL: string;
  clubList: any;
  playerBookingTypeAssociation: PlayerBookingTypeAssociation;
  selectedPlayerType: BookingPlayerType;
  data: any;
  // for insurance
  insuranceName: string;
  partnerInfo: DiscountCompany;
  fromPartner: boolean = false;
  insuranceNo: string;
  playerInsurance: PlayerInsurance;
  selectedInsuranceCompany: DiscountCompany;
  insuranceValidFrom: string;
  insuranceValidUntil: string;
  insuranceApplicableIn: Array<string>;
  insuranceMaxDate: string;
  imageBlob: Blob;
  globalFormData = new FormData();
  countryList: Array<Country>;
  addPlayerMode: boolean = false;
  selectedFiles: any = [];
  previewImage: Array<any>;
  afuConfig: any;
  @Input() forSpecificOnly: boolean = false;
  @Input() specificType: string = '';


  @ViewChild('fileInput')
  fileInput: ElementRef;

  constructor(
    private flightService: ClubFlightService,
    private navParams: NavParams,
    private toastCtl: ToastController,
    private platform: Platform,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private imageService: ImageService,
    private loadingCtl: LoadingController,
    private playerHomeActions: PlayerHomeActions,
    private actionSheetCtl: ActionSheetController,
    private playerService: PlayerService,
    private loadingCtrl: LoadingController
  ) {
    // headerTitle: headerTitle,
    // type: type,
    // mode: 'edit',
    // pdp: pdp,
    // playerInsurance: pdp,
    // player: this.player,
    // fromClub: this.fromClub,
    // clubId: this.clubInfo && this.clubInfo.id ? this.clubInfo.id : null,
    this.courses = navParams.get('courses');
    this.clubId = navParams.get('clubId');
    this.forDate = navParams.get('forDate');
    this.courseId = navParams.get('courseId');
    this.changeType = navParams.get('changeType');
    this.currentSlot = navParams.get('currentSlot');
    if (this.changeType && this.changeType === 'slot') this.isClub = false;
    else if (this.changeType && this.changeType === 'course')
      this.isClub = true;
    this.mode = navParams.get('mode');
    this.type = navParams.get('type');
    this.headerTitle = navParams.get('headerTitle');
    this.player = navParams.get('player');
    this.forBooking = navParams.get('forBooking');
    this.fromClub = navParams.get('fromClub');
    this.playerDiscountProgram = navParams.get('pdp');
    this.playerInsurance = navParams.get('playerInsurance');

    if (this.type === 'playerDiscount') this.data = navParams.get('data');
    // this.data = navParams
    if (navParams.get('partnerInfo')) {
      this.partnerInfo = navParams.get('partnerInfo');
      this.selectedDiscountCompany = this.partnerInfo;
      this.fromPartner = true;

    }
    this.addPlayerMode = navParams.get('addPlayerMode');

    this.playerTypes = [
      {
        id: 'ARMY',
        name: 'Armed Forces',
        use: true,
      },
      {
        id: 'GOVT',
        name: 'Government',
        use: true,
      },
      {
        id: 'GUEST',
        name: "Member's Guest",
        use: false,
      },
      {
        id: 'JUNIOR',
        name: 'Junior',
        use: true,
      },
      {
        id: 'MEMBER',
        name: 'Club Member',
        use: true,
      },
      {
        id: 'POLICE',
        name: 'Police',
        use: true,
      },
      {
        id: 'SENIOR',
        name: 'Senior Citizen',
        use: true,
      },
      {
        id: 'STAFF',
        name: 'Staff',
        use: true,
      },
      {
        id: 'TMEMBER',
        name: 'Term Member',
        use: true,
      },
    ];
    this.playerTypes.sort((a, b) => {
      if (a.name < b.name) return -1;
      else if (a.name > b.name) return 1;
      else return 0;
    });

    this.discountCards = [
      {
        id: 'AGSSG 1',
        name: 'Staff',
        use: true,
      },
      {
        id: 'AGSSG 2',
        name: 'Term Member',
        use: true,
      },
    ];


    if (this.mode === 'edit') {
      this.cardValidFrom = moment(
        this.playerDiscountProgram.validFrom,
        'YYYY-MM-DD'
      ).format('YYYY-MM-DD'); // moment().format("YYYY-MM-DD");
      this.cardValidUntil = moment(
        this.playerDiscountProgram.validUntil,
        'YYYY-MM-DD'
      ).format('YYYY-MM-DD'); // moment().add(1,'months').format("YYYY-MM-DD");
      this.cardMembershipNo = this.playerDiscountProgram.membershipNumber;
      this.selectedDiscountProgram = this.playerDiscountProgram?.discountProgram?.id;
    }
    if (this.mode === 'view') {
      this.cardValidFrom = moment(
        this.playerDiscountProgram.validFrom,
        'YYYY-MM-DD'
      ).format('YYYY-MM-DD'); // moment().format("YYYY-MM-DD");
      this.cardValidUntil = moment(
        this.playerDiscountProgram.validUntil,
        'YYYY-MM-DD'
      ).format('YYYY-MM-DD'); // moment().add(1,'months').format("YYYY-MM-DD");
      this.cardMembershipNo = this.playerDiscountProgram.membershipNumber;
    } else {
      this.cardValidFrom = moment().format('YYYY-MM-DD');
      this.cardValidUntil = moment().add(1, 'months').format('YYYY-MM-DD');
      this.insuranceValidFrom = moment().format('YYYY-MM-DD');
      this.insuranceValidUntil = moment().add(1, 'years').format('YYYY-MM-DD');
    }
    this.cardMaxDate = moment().add(10, 'years').format('YYYY-MM-DD');
    this.insuranceMaxDate = moment().add(10, 'years').format('YYYY-MM-DD');
    this.initFileUpload();
  }
  initFileUpload() {
    this.afuConfig = {
      multiple: false,
      formatsAllowed: '.jpg,.png',
      maxSize: '1',
      uploadAPI: {
        url: 'https://example-file-upload-api',
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=UTF-8',
          //  "Authorization" : `Bearer ${token}`
        },
      },
      theme: 'dragNDrop',
      hideProgressBar: true,
      hideResetBtn: true,
      hideSelectBtn: true,
    };
  }
  ngOnInit() {
    this.getCountry();
    if (this.mode === 'new') {
      if (this.type === 'playerType') {
        Promise.all([this.getAssignablePlayerTypes()])
        .then((results: Array<any>)=>{

        console.debug("entering add player type", results, this.forSpecificOnly, this.specificType, this.playerTypes, this.selectedPlayerType)
        if(results?.some(result => result)) {
          if(this.forSpecificOnly && this.specificType?.length) {

            this.selectedPlayerType = this.playerTypes.find(pType => pType.id === this.specificType);
          }
        }
        });
      } else {
        this.getListDiscountCompanies();
      }
      if (this.partnerInfo) {
        this.selectedDiscountCompany = this.partnerInfo;
        this.getDiscountPrograms(this.selectedDiscountCompany);
      }
    }
    if (this.mode === 'edit') {
      if (this.type === 'playerInsurance') {
        this.insuranceNo = this.playerInsurance.insuranceNo;
        if (this.playerInsurance.partner)
          this.selectedInsuranceCompany = this.playerInsurance.partner;
        // else this.selectedInsuranceCompany.name = this.playerInsurance.insuranceCompany;
        this.insuranceName = this.playerInsurance.name;
        this.insuranceValidFrom = moment(
          this.playerInsurance.startDate,
          'YYYY-MM-DD'
        ).format('YYYY-MM-DD');
        this.insuranceValidUntil = moment(
          this.playerInsurance.endDate,
          'YYYY-MM-DD'
        ).format('YYYY-MM-DD');
      } else {
        this.getListApplications();
        this.getRecognizedClub();
      }
      if (this.partnerInfo) {
        this.selectedDiscountCompany = this.partnerInfo;
        this.getDiscountPrograms(this.selectedDiscountCompany);
      }
    }
    if (this.mode === 'approval') {
      if (this.type === 'playerInsurance') {
      } else {
        this.getListApplications();
        this.getRecognizedClub();
      }
    }
  }
  async getCountry() {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
        this.countryList = data;
        if (this.mode === 'edit' && this.type === 'playerInsurance') {
            this.insuranceApplicableIn = this.playerInsurance.applicableIn;
        }
    });
  }

  close() {
    this.modalCtrl.dismiss({
      created: false,
    });
  }
  selectHole(hole: CourseHoleInfo, whichNine: number) {
    this.modalCtrl.dismiss({
      hole: hole,
      whichNine: whichNine,
    });
  }

  getRecognizedClub() {
    this.clubList = {};
    let _programId = this.playerDiscountProgram.discountProgram.id;
    this.flightService
      .listDiscountProgramsClub(_programId)
      .subscribe((data) => {
        if (data) {
          let clubList = data;
          if (clubList.success && clubList.totalItems > 0) {
            this.clubList.totalItems = clubList.totalItems;
          } else if (clubList.success && clubList.totalItems === 0) {
            this.clubList.totalItems = clubList.totalItems;
          }
        } else this.clubList.totalItems = 0;
      });
  }

  getTeeTimeBookingList() {
    let _clubCourseId;
    this.startCourses = [];
    _clubCourseId = this.isClub ? this.clubId : this.courseId;
    this.flightService
      .getTeeTimeSlot(this.forDate, this.isClub, _clubCourseId)
      .subscribe((data: Array<TeeTimeSlotDisplay>) => {
        this.teeSlot = data;
        if (this.changeType === 'course') {
          this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
            return (
              tee.slot.teeOffTime ===
              this.currentSlot.slotAssigned.teeOffTime &&
              tee.slot.startCourse.id !==
              this.currentSlot.slotAssigned.startCourse.id
            );
          });
        } else {
          this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
            return (
              tee.slot.teeOffTime !== this.currentSlot.slotAssigned.teeOffTime
            );
          });
        }
        this.teeSlot.forEach((t: TeeTimeSlotDisplay) => {
          this.startCourses.push(t.slot.startCourse);
        });
        this.startCourses = this.getUnique(this.startCourses, 'id');
        this.startCourses.sort((a, b) => {
          if (a.displayOrder < b.displayOrder) return -1;
          if (a.displayOrder > b.displayOrder) return 1;
          else 0;
        });
      });
  }

  getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }

  changeSlot(slot: TeeTimeSlotDisplay, type?: string) {
    if (!slot.available && type === 'slot') return false;
    this.flightService
      .getBookingFlightList(
        this.clubId,
        moment(slot.slot.teeOffDate).format('YYYY-MM-DD'),
        true
      )
      .subscribe((data) => {
        let _flightList: Array<TeeTimeBooking>;
        let _hasFlight: Array<TeeTimeBooking>;
        if (data) {
          _flightList = data.flightList;
          _hasFlight = _flightList.filter((t: TeeTimeBooking) => {
            return (
              t.slotAssigned.slotNo === slot.slot.slotNo &&
              t.slotAssigned.slotDayId === slot.slot.slotDayId
            );
          });
        }
        if (_hasFlight && _hasFlight.length > 0) {
          if (
            _hasFlight[0].flight &&
            _hasFlight[0].flight.status === 'PlayFinished'
          ) {
            MessageDisplayUtil.showMessageToast(
              'There is Finished Flight in this slot. Please choose different slot.',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          } else {
            this.modalCtrl.dismiss({
              newSlot: slot,
              currentSlot: this.currentSlot,
            });
          }
        } else {
          this.modalCtrl.dismiss({
            newSlot: slot,
            currentSlot: this.currentSlot,
          });
        }
      });
  }
  getSlotDetails(slot: TeeTimeSlotDisplay, attribute: string) {
    switch (attribute) {
      case 'time':
        let _time = moment(slot.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        return _time;
    }
  }
  getCurrentSlotDetails(attribute) {
    switch (attribute) {
      case 'time':
        let _time = moment(
          this.currentSlot.slotAssigned.teeOffTime,
          'HH:mm:ss'
        ).format('hh:mm A');
        return _time;
      case 'courseName':
        let _courseName = this.currentSlot.slotAssigned.startCourse.name;
        return _courseName;
    }
  }

  getSlotClass(slot: TeeTimeSlotDisplay) {
    if (this.changeType === 'course') return 'slot-available';
    else {
      // return this.color
      if (slot.available) return 'slot-available';
      else return 'slot-not-available';
    }
  }

  setOptionType(type: number) {
    if (type === 1) {
      this.optionTypes = 'details';
    }
    if (type === 2) {
      this.optionTypes = 'clubApprovals';
      // this.mode = 'approval';
      this.getListApplications();
    }
    if (type === 3) {
      this.optionTypes = 'voucher';
    }
  }

  getListDiscountCompanies() {
    this.flightService.getDiscountCompanies().subscribe((data: any) => {
      if (data && data.success) {
        this.discountCompanies = data.items;
      }
    });
  }
  // onAddDiscountCard() {
  //     if (!this.selectedDiscountCompany) {
  //         MessageDisplayUtil.showMessageToast('Please select Discount Company',
  //             this.platform, this.toastCtl, 3000, "bottom");
  //         return false;
  //     }
  //     if (!this.selectedDiscountProgram) {
  //         MessageDisplayUtil.showMessageToast('Please select Discount Program',
  //             this.platform, this.toastCtl, 3000, "bottom");
  //         return false;
  //     }
  //     if (!this.cardMembershipNo || (this.cardMembershipNo && this.cardMembershipNo.length === 0)) {
  //         MessageDisplayUtil.showMessageToast('Please enter membership number',
  //             this.platform, this.toastCtl, 3000, "bottom");
  //         return false;
  //     }
  //     if (this.cardValidFrom >= this.cardValidUntil) {
  //         MessageDisplayUtil.showMessageToast('Please enter valid dates',
  //             this.platform, this.toastCtl, 3000, "bottom");
  //         return false;
  //     }
  //     let _playerId = this.player.playerId ? this.player.playerId : this.player.id; // | this.player.id;

  //     let _programId = this.selectedDiscountProgram;
  //     let _membershipNo = this.cardMembershipNo;
  //     let _clubId = this.fromClub ? this.clubId : null;
  //     let _validFrom = moment(this.cardValidFrom).format("YYYY-MM-DD");
  //     let _validUntil = moment(this.cardValidUntil).format("YYYY-MM-DD");
  //     let _msg;
  //     this.flightService.createPlayerDiscountCard(_playerId, _programId, _membershipNo, _validFrom, _validUntil)
  //         .subscribe((data) => {
  //             if (data) {

  //                 // if (data.status === 200) {
  //                 let _data = data;
  //                 let _existing = false;

  //                 // if (this.data) {
  //                 //     this.data.filter((d) => {
  //                 //         if (d.id === _data.id) _existing = true;
  //                 //     })
  //                 // } //Changed because data is not passed in component Props -Rajiv
  //                 if (this.playerDiscountProgram && this.playerDiscountProgram.id == _data.id) {
  //                     _existing = true;
  //                 }
  //                 if (_existing) _msg = 'Successfully updated card #id : ' + _data.membershipNumber;
  //                 else _msg = 'Successfully added new card';
  //                 MessageDisplayUtil.showMessageToast(_msg,
  //                     this.platform, this.toastCtl, 3000, "bottom");
  //                 this.playerDiscountProgram = _data;
  //                 if (this.isCordova() && this.temporaryImageURL) this._uploadImage(this.temporaryImageURL);

  //                 if (!this.fromClub)
  //                     this.modalCtrl.dismiss({
  //                         created: true
  //                     })
  //                 if (this.fromClub) {

  //                     this.flightService.applyForClubVerifyDiscountCard(_playerId, _programId, _clubId)
  //                         .subscribe((data) => {
  //                             if (data) {

  //                                 if (this.fromClub) {
  //                                     this.flightService.approvePlayerDiscountCard(_playerId, _programId, _clubId)
  //                                         .subscribe((data) => {
  //                                             if (data) {
  //                                                 this.modalCtrl.dismiss({
  //                                                     created: true
  //                                                 })
  //                                             } else {
  //                                                 this.modalCtrl.dismiss({
  //                                                     created: true
  //                                                 })
  //                                             }
  //                                         }), (error) => {
  //                                             let _error = error;
  //                                             let _msg = 'Error reaching server at the moment. Please try again';
  //                                             if (_error.errors[0]) _msg = "Error - " + _error.errors[0];
  //                                             MessageDisplayUtil.showMessageToast(_msg,
  //                                                 this.platform, this.toastCtl, 3000, "bottom");
  //                                         }
  //                                 } else {
  //                                     this.modalCtrl.dismiss({
  //                                         created: true
  //                                     })
  //                                 }
  //                             } else {

  //                                 this.modalCtrl.dismiss({
  //                                     created: true
  //                                 })
  //                             }
  //                         }, (error) => {
  //                             let _error = error;
  //                             let _msg = 'Error reaching server at the moment. Please try again';
  //                             if (_error.errors[0]) _msg = "Error - " + _error.errors[0];
  //                             MessageDisplayUtil.showMessageToast(_msg,
  //                                 this.platform, this.toastCtl, 3000, "bottom");
  //                         })
  //                 }
  //                 // }
  //             }
  //         }, (error) => {
  //             let _error = error;
  //             let _msg;
  //             if (_error.status === 404) _msg = _error.status + ' - ' + _error.error + ' .' + _error.message;
  //             else if (_error.errors && _error.errors.length > 0) _msg = _error.errors[0];
  //             else _msg = 'Error connecting to server. Please try again.'
  //             MessageDisplayUtil.showErrorToast(_msg,
  //                 this.platform, this.toastCtl, 3000, "bottom");
  //             return false;
  //         })
  // }

  onAddDiscountCard() {
    if (!this.selectedDiscountCompany) {
      MessageDisplayUtil.showMessageToast(
        'Please select Discount Company',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (!this.selectedDiscountProgram) {
      MessageDisplayUtil.showMessageToast(
        'Please select Discount Program',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (
      !this.cardMembershipNo ||
      (this.cardMembershipNo && this.cardMembershipNo.length === 0)
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please enter membership number',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (this.cardValidFrom >= this.cardValidUntil) {
      MessageDisplayUtil.showMessageToast(
        'Please enter valid dates',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    let _playerId = this.player?.playerId
      ? this.player.playerId
      : this.player.id; // | this.player.id;

    let _programId = this.selectedDiscountProgram;
    let _membershipNo = this.cardMembershipNo;
    let _clubId = this.fromClub ? this.clubId : null;
    let _validFrom = moment(this.cardValidFrom).format('YYYY-MM-DD');
    let _validUntil = moment(this.cardValidUntil).format('YYYY-MM-DD');
    let _msg;

    this.flightService
      .createPlayerDiscountCard(
        _playerId,
        _programId,
        _membershipNo,
        _validFrom,
        _validUntil
      )
      .subscribe(
        (data) => {
          if (data) {
            // if (data.status === 200) {
            // let _data = data.json();
            let _data = data;
            let _existing = false;

            if (this.data) {
              this.data.filter((d) => {
                if (d.id === _data.id) _existing = true;
              });
            }
            if (_existing)
              _msg =
                'Successfully updated card #id : ' + _data.membershipNumber;
            else _msg = 'Successfully added new card';
            MessageDisplayUtil.showMessageToast(
              _msg,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            this.playerDiscountProgram = _data;
            if (this.temporaryImageURL)
              this._uploadImage(this.temporaryImageURL);

            if (!this.fromClub)
              this.modalCtrl.dismiss({
                created: true,
              });
            if (this.fromClub) {
              this.flightService
                .applyForClubVerifyDiscountCard(_playerId, _programId, _clubId)
                .subscribe(
                  (data) => {
                    if (data) {
                      let _playerDiscountProgramId: Array<number> = [];
                      _playerDiscountProgramId.push(
                        data.playerDiscountProgram.id
                      );
                      if (this.fromClub) {
                        this.flightService
                          .approvePlayerDiscountCard(
                            _playerId,
                            _playerDiscountProgramId,
                            _clubId
                          )
                          .subscribe(
                            (data) => {
                              if (data) {
                                this.modalCtrl.dismiss({
                                  created: true,
                                });
                              } else {
                                this.modalCtrl.dismiss({
                                  created: true,
                                });
                              }
                            },
                            (error) => {
                              let _error = error;
                              let _msg =
                                'Error reaching server at the moment. Please try again';
                              if (_error.errors[0])
                                _msg = 'Error - ' + _error.errors[0];
                              MessageDisplayUtil.showMessageToast(
                                _msg,
                                this.platform,
                                this.toastCtl,
                                3000,
                                'bottom'
                              );
                            }
                          );
                      } else {
                        this.modalCtrl.dismiss({
                          created: true,
                        });
                      }
                    } else {
                      this.modalCtrl.dismiss({
                        created: true,
                      });
                    }
                  },
                  (error) => {
                    let _error = error;
                    let _msg =
                      'Error reaching server at the moment. Please try again';
                    if (_error.errors[0]) _msg = 'Error - ' + _error.errors[0];
                    MessageDisplayUtil.showMessageToast(
                      _msg,
                      this.platform,
                      this.toastCtl,
                      3000,
                      'bottom'
                    );
                  }
                );
            }
            // }
          }
        },
        (error) => {
          // let _error = error.json();
          let _error = error;
          let _msg;
          if (_error.status === 404)
            _msg = _error.status + ' - ' + _error.error + ' .' + _error.message;
          else if (_error.errors && _error.errors.length > 0)
            _msg = _error.errors[0];
          else _msg = 'Error connecting to server. Please try again.';
          MessageDisplayUtil.showErrorToast(
            _msg,
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          return false;
        }
      );
  }

  getDiscountCompanyName() {
    return this.selectedDiscountCompany && this.selectedDiscountCompany.name
      ? this.selectedDiscountCompany.name
      : 'Select Discount Company (tap here)';
  }

  async onSearchDiscountCompany() {
    let _type = 'discount';
    let modal = await this.modalCtrl.create({
      component: SearchDiscountCompanyPage,
      componentProps: {
        headerTitle: 'Select Discount Company',
        partnerType: _type
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data && data.data.selected) {
        this.selectedDiscountCompany = data.data.discCompany;
        this.getDiscountPrograms(this.selectedDiscountCompany);
        setTimeout(() => {
          if (
            (this.discountPrograms && this.discountPrograms.length === 0) ||
            !this.discountPrograms
          ) {
            MessageDisplayUtil.showMessageToast(
              'There is no program under this company. Please choose different company',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
          } else if(this.discountPrograms?.length === 1) {
            this.selectedDiscountProgram = this.discountPrograms[0].id;
          }
        }, 500);
      }
    });
    modal.present();
  }

  getDiscountPrograms(discountCompany: DiscountCompany) {
    if (!discountCompany) return false;
    let _companyId = discountCompany.id;
    this.flightService
      .getDiscountPrograms(_companyId)
      .subscribe((data: any) => {
        if(data) this.discountPrograms = data.filter((dp: DiscountCompanyProgram)=>{
            return dp && dp.includesDiscount && !dp.includesHandicap
        });
      });
  }

  onValidFromChange() {
    this.cardValidUntil = moment(this.cardValidFrom)
      .add(1, 'months')
      .format('YYYY-MM-DD');
  }

  async onPrivilegeApplyClub(pdp: PlayerDiscountProgram) {
    this.onClubSelect(pdp);
    if (1) return false;

    let prompt = await this.alertCtrl.create({
      header: 'Apply Discount Program',
      message:
        'This will apply discount program to this club. Do you want to proceed? ',
      buttons: [
        {
          text: 'No',
          handler: (data) => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            prompt.dismiss().then(() => {
              this.onClubSelect(pdp);
            });
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  goApplyPrivilegeClub(pdp: PlayerDiscountProgram, clubId?: number) {
    let _playerId = pdp.player.playerId ? pdp.player.playerId : pdp.player.id;
    let _programId = pdp.discountProgram.id;
    let _clubId = clubId;
    this.flightService
      .applyForClubVerifyDiscountCard(_playerId, _programId, _clubId)
      .subscribe(
        (data) => {
          this.getListApplications();
        },
        (error) => {
          let _error = error;
          if (_error && _error.status !== 200) {
            let _msg = _error.errors[0];
            if (_error.errorCode.includes('DiscountProgramNotRecognized'))
              _msg =
                'There is no valid club discount associated to this card. Please check validity dates.';
            MessageDisplayUtil.showMessageToast(
              _msg,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
        },
        () => {
          this.getListApplications();
        }
      );
  }

  async onClubSelect(pdp: PlayerDiscountProgram) {
    let club = await this.modalCtrl.create({
      component: ProgramClubListPage,
      componentProps: {
        openedModal: true,
        multiSelect: true,
        programId: this.playerDiscountProgram.discountProgram.id,
      },
    });

    club.onDidDismiss().then((data: any) => {
      let _clubs: Array<ClubData>;
      if (data && data.data && data.data.confirm) {
        if (data.data.multiClub && data.data.multiClub.length > 0)
          _clubs = data.data.multiClub;
        _clubs.forEach((c: ClubData, idx: number) => {
          this.goApplyPrivilegeClub(pdp, c.id);
        });
      }
    });
    club.present();
  }

  getListApplications() {
    this.pendingPDP = [];
    let _playerId = this.player.playerId
      ? this.player.playerId
      : this.player.id;
    let _clubId;
    let _program = this.playerDiscountProgram.discountProgram;
    this.flightService
      .getListAllCardApplyForPlayer(_playerId, _program.id)
      .subscribe((data) => {
        let _pdp: Array<DiscountPlayerClub>;
        if (data && data.length > 0) {
          _pdp = data;
          this.pendingPDP = _pdp;
          this.pendingPDP.forEach((pdp: DiscountPlayerClub) => {
            let club = pdp.club;
            JsonService.deriveFulImageURL(club, 'clubImage');
            JsonService.deriveFulImageURL(club, 'clubThumbnail');
            JsonService.deriveFulImageURL(club, 'clubLogo');
          });
        }
      });
  }
  getClubImage(club: ClubData) {
    let _imageUrl;
    if (club.clubThumbnail) _imageUrl = club.clubThumbnail;
    else if (club.clubImage) _imageUrl = club.clubImage;
    else if (club.clubLogo) _imageUrl = club.clubLogo;
    else _imageUrl = '';
    return _imageUrl;
  }
  async onUploadCardClick(pdp?: PlayerDiscountProgram) {
    let _buttons = [];
    _buttons.push({
      text: 'Select Photo',
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        this.takePhotoFromGallery(null);
      },
    });
    _buttons.push({
      text: 'Take Photo',
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        this.onTakePhotoPlayerCard();
      },
    });

    let actionSheet = await this.actionSheetCtl.create({
      buttons: _buttons,
    });
    actionSheet.present();
  }
  onTakePhotoPlayerCard() {
    this.imageService.captureImage(true).then((image: any) => {
      if (this.mode === 'new') {
        const imageBlob = this.imageService.dataURLtoBlob(image.dataUrl);
        this.selectedFiles = imageBlob;
          this.temporaryImageURL = image.dataUrl;
          // this._uploadImage(this.temporaryImageURL);
        // this.temporaryImageURL = data.dataUrl;
      } else {
        const imageBlob = this.imageService.dataURLtoBlob(image.dataUrl);
        this.selectedFiles = imageBlob;
          this.temporaryImageURL = image.dataUrl;
          if(this.type !== 'playerInsurance')
          this._uploadImage(this.temporaryImageURL);
        // this._uploadImage(data.dataUrl);
      }
    });
  }

  onUploadCardDocument() {
    this.imageService.pickImage().then((data: any) => {
      if (this.mode === 'new') this.temporaryImageURL = data.dataUrl;
      else this._uploadImage(data.dataUrl);
    });
  }
  async _uploadImage(imageURL: string, params?: any) {
    let _playerDiscountCardId;
    let _contentType;
    // if (this.type !== 'playerType') {
    //   _playerDiscountCardId = this.playerDiscountProgram.id;
    // }
    if (this.type === 'playerDiscount') {
      _playerDiscountCardId = this.playerDiscountProgram.id;
    }
    let uploadLoading = await this.loadingCtl.create({
      message: 'Uploading, Please wait...',
    });
    if (this.type === 'playerType') {
      let _playerId = this.player.playerId;
      if(this.forSpecificOnly && this.specificType?.length) _playerId = this.player?.id;

      if (1) {
        // !this.isCordova()

        uploadLoading.present().then(() => {
          // ContentType.JPEG
          this.flightService
            .addPlayerTypeWeb(
              this.selectedFiles,
              imageURL,
              ContentType.WILDCARD_IMAGE,
              _playerId, //this.player.playerId,
              this.selectedPlayerType.id,
              null,
              this.globalFormData
            ).subscribe(
              (data) => {
                uploadLoading.dismiss().then(() => {
                  // if(data) this.playerDiscountProgram = data;
                  if (data) this.temporaryImageURL = imageURL;
                  // this.cancelEditImage();
                });
              },
              (error) => {

                uploadLoading.dismiss().then(async () => {
                  // let _error = error.error;
                  // if(error.json()) _error = error.json();
                  // else _error = error.error;
                  let _msg = 'Please upload photo not more than 10 MB';
                  // if(_error && _error.errorMessage) _msg = _error.errorMessage;
                  // 'Please upload photo not more than 10 MB'
                  // if(error || error !== null) {
                  let alert = await this.alertCtrl.create({
                    header: 'Upload Error',
                    message: _msg,
                    buttons: ['Ok'],
                  });
                  alert.present();
                  // }
                  // else this.cancelEditImage();
                });
              },
              () => {
                this.modalCtrl.dismiss({
                  created: true,
                });
              }
            );
        });
      } else {

        uploadLoading.present().then(() => {
          // ContentType.JPEG
          this.playerHomeActions
            .addPlayerType(
              imageURL,
              ContentType.WILDCARD_IMAGE,
              this.player.playerId,
              this.selectedPlayerType.id
            )
            .subscribe(
              (data) => {
                uploadLoading.dismiss().then(() => {
                  // if(data) this.playerDiscountProgram = data;
                  if (data) this.temporaryImageURL = imageURL;
                  // this.cancelEditImage();
                });
              },
              (error) => {

                uploadLoading.dismiss().then(async () => {
                  // 'Please upload photo not more than 10 MB'
                  // if(error || error !== null) {
                  let alert = await this.alertCtrl.create({
                    header: 'Upload Error',
                    message: 'Please upload photo not more than 10 MB',
                    buttons: ['Ok'],
                  });
                  alert.present();
                  // }
                  // else this.cancelEditImage();
                });
              },
              () => {
                this.modalCtrl.dismiss({
                  created: true,
                });
              }
            );
        });
      }
    } else if (this.type === 'playerInsurance') {
      let _mode = 'new';
      if (this.mode === 'edit') _mode = this.mode;

      let _playerId = this.player.playerId | this.player.id; // = this.player.playerId?this.player.playerId:this.player.id; // | this.player.id;
      uploadLoading.present().then(() => {
        // ContentType.JPEG
        console.debug("uploading insurance document", this.selectedFiles, imageURL, ContentType.WILDCARD_IMAGE, _playerId, params, _mode);
        this.playerHomeActions
          .uploadPlayerInsuranceDocument(
            imageURL,
            ContentType.WILDCARD_IMAGE,
            _playerId,
            params,
            _mode,
            this.selectedFiles
          )
          .subscribe(
            (data) => {
              uploadLoading.dismiss().then(() => {
                // if(data) this.playerDiscountProgram = data;
                if (data) this.temporaryImageURL = imageURL;
                // this.cancelEditImage();
              });
            },
            (error) => {

              uploadLoading.dismiss().then(async () => {
                // 'Please upload photo not more than 10 MB'
                // if(error || error !== null) {
                let alert = await this.alertCtrl.create({
                  header: 'Upload Error',
                  message: 'Please upload photo not more than 10 MB',
                  buttons: ['Ok'],
                });
                alert.present();
                // }
                // else this.cancelEditImage();
              });
            },
            () => {
              this.modalCtrl.dismiss({
                created: true,
              });
            }
          );
      });
    } else {
      if (1) {
        // if (!this.isCordova()) {
        uploadLoading.present().then(() => {
          // this.imageData
          this.flightService
            .uploadPlayerCardDiscountWeb(
              this.selectedFiles,
              imageURL,
              _playerDiscountCardId
            )
            .subscribe(
              (data) => {
                uploadLoading.dismiss().then(() => {
                  // if(data) this.playerDiscountProgram = data;
                  if (data) this.temporaryImageURL = imageURL;
                  // this.cancelEditImage();
                });
              },
              (error) => {

                uploadLoading.dismiss().then(async () => {
                  // let _error = error.error;
                  // if(error.json()) _error = error.json();
                  // else _error = error.error;
                  let _msg = 'Please upload photo not more than 10 MB';
                  // if(_error && _error.errorMessage) _msg = _error.errorMessage;
                  // 'Please upload photo not more than 10 MB'
                  // if(error || error !== null) {
                  let alert = await this.alertCtrl.create({
                    header: 'Upload Error',
                    message: _msg,
                    buttons: ['Ok'],
                  });
                  alert.present();
                  // }
                  // else this.cancelEditImage();
                });
              },
              () => {
                this.modalCtrl.dismiss({
                  created: true,
                });
              }
            );
        });
      } else {
        uploadLoading.present().then(() => {
          // this.imageData
          this.playerHomeActions
            .uploadPlayerCardDiscount(
              imageURL,
              ContentType.WILDCARD_IMAGE,
              _playerDiscountCardId
            )
            .subscribe(
              (data) => {
                uploadLoading.dismiss().then(() => {
                  // if(data) this.playerDiscountProgram = data;
                  if (data) this.playerDiscountProgram.document = imageURL;

                  // this.cancelEditImage();
                });
              },
              (error) => {

                uploadLoading.dismiss().then(async () => {
                  // 'Please upload photo not more than 10 MB'
                  // if(error || error !== null) {
                  let alert = await this.alertCtrl.create({
                    header: 'Upload Error',
                    message: 'Please upload photo not more than 10 MB',
                    buttons: ['Ok'],
                  });
                  alert.present();
                  // }
                  // else this.cancelEditImage();
                });
              }
            );
        });
      }
    }
  }

  isCordova() {
    return this.platform.is('capacitor');
  }

  async onZoomImage(image: string) {
    let imageZoom = await this.modalCtrl.create({
      component: ImageZoomPage,
cssClass: 'self-adjustable-modal',
      componentProps: {
        image: image,
      },
    });
    imageZoom.onDidDismiss().then((data: any) => { });
    imageZoom.present();
  }

  getAssignablePlayerTypes() {
    return new Promise((resolve, reject) => {
      this.playerTypes = [];
      this.flightService
        .assignableBookingPlayerType()
        .subscribe((data: Array<BookingPlayerType>) => {
          if (data) {
            this.playerTypes = data.filter((p) => {
              if (p.id === 'LADIES') return false;
              else if (p.id === 'JUNIOR') return false;
              else if (p.id === 'SENIOR') return false;
              else if (p.id === 'MEMBER') return false;
              else if (p.id === 'TMEMBER') return false;
              else return true;
            });
          }
          this.playerTypes.push({
            id: 'STD',
            name: 'Local Visitor/Resident',
          });
          resolve(true)
        });

    });
  }

  onAddPlayerType() {
    if (!this.selectedPlayerType) {
      MessageDisplayUtil.showMessageToast(
        'Please select a Player Type',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (!this.temporaryImageURL) {
      MessageDisplayUtil.showMessageToast(
        'Please upload the document',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    // if (this.isCordova())
    this._uploadImage(this.temporaryImageURL);
  }

  async onRemoveClubApplication(pdp: DiscountPlayerClub) {
    let prompt = await this.alertCtrl.create({
      header: 'Remove Club Application',
      message:
        'This will remove application from this club. Do you want to proceed? ',
      buttons: [
        {
          text: 'No',
          handler: (data) => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            prompt.dismiss().then(() => {
              this.goRemoveClubApplication(pdp);
            });
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  goRemoveClubApplication(pdp: DiscountPlayerClub) {
    let _clubId = pdp.club.id;
    let _playerDiscountId = pdp.playerDiscountProgram.id;
    this.flightService
      .removeCardClubApplication(_clubId, _playerDiscountId)
      .subscribe(
        (data: any) => {
          this.getListApplications();
        },
        (error) => {
          if (error) {
            MessageDisplayUtil.showErrorToast(
              'Something is wrong with the server. Please try again.',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
        },
        () => {
          this.getListApplications();
          MessageDisplayUtil.showErrorToast(
            'Successfully removed club application for this card',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          return false;
        }
      );
  }

  onUpdateDiscountCard() {
    if (
      !this.cardMembershipNo ||
      (this.cardMembershipNo && this.cardMembershipNo.length === 0)
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please enter membership number',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (this.cardValidFrom >= this.cardValidUntil) {
      MessageDisplayUtil.showMessageToast(
        'Please enter valid dates',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    let _playerId = this.player.playerId
      ? this.player.playerId
      : this.player.id; // | this.player.id;

    let _programId = this.selectedDiscountProgram; // this.playerDiscountProgram.discountProgram.id;
    let _membershipNo = this.cardMembershipNo;
    let _clubId = this.fromClub ? this.clubId : null;
    let _validFrom = moment(this.cardValidFrom).format('YYYY-MM-DD');
    let _validUntil = moment(this.cardValidUntil).format('YYYY-MM-DD');
    let _msg;

    let _partnerId = this.partnerInfo
      ? this.partnerInfo.id
      : this.playerDiscountProgram.discountProgram.discountCompany.id;
    let _playerMembershipId = this.playerDiscountProgram.id;
    let _params = {
      validFrom: _validFrom,
      validUntil: _validUntil,
      membershipNumber: _membershipNo,
      programId: _programId,
    };

    if (1) {
      // this.fromPartner
      console.debug("updating program membership", _partnerId, _playerMembershipId, _params, this.selectedDiscountProgram, this.playerDiscountProgram)
      // if(1) return;
      this.flightService
        .updateProgramMembership(_partnerId, _playerMembershipId, _params)
        .subscribe(
          (data) => {
            if (data) {

              if (data) {
                let _data = data;
                let _existing = false;

                if (
                  this.playerDiscountProgram &&
                  this.playerDiscountProgram.id === data.id
                ) {
                  _existing = true;
                  // this.playerDiscountProgram.filter((d)=>{
                  //     if(d.id === _data.id) _existing = true;
                  // })
                  // let _msg = "Successfully updated discount card";
                  // MessageDisplayUtil.showErrorToast(_msg,
                  //     this.platform , this.toastCtl,3000, "bottom");
                  // return false;
                }
                if (_existing)
                  _msg =
                    'Successfully updated card #id : ' + _data.membershipNumber;
                else if (this.mode === 'edit')
                  _msg = 'Successfully updated the card';
                else _msg = 'Successfully added new card';
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                this.playerDiscountProgram = _data;
                if (this.temporaryImageURL)
                  this._uploadImage(this.temporaryImageURL);
                else if (!this.isCordova() && this.temporaryImageURL)
                  this._uploadImage(this.temporaryImageURL);

                if (!this.fromClub)
                  this.modalCtrl.dismiss({
                    created: true,
                  });
                if (this.fromPartner)
                  this.modalCtrl.dismiss({
                    created: true,
                  });
                // if(this.fromClub) {

                // this.flightService.applyForClubVerifyDiscountCard(_playerId, _programId, _clubId)
                // .subscribe((data)=>{
                //     if(data) {

                //         if(this.fromClub) {
                //             this.flightService.approvePlayerDiscountCard(_playerId, _programId, _clubId)
                //             .subscribe((data)=>{
                //                 if(data) {
                //                     this.viewCtrl.dismiss({
                //                         created: true
                //                     })
                //                 } else {
                //                     this.viewCtrl.dismiss({
                //                         created: true
                //                     })
                //                 }
                //             }, (error)=>{
                //                 let _error = error.json();
                //
                //                 let _msg = 'Error reaching server at the moment. Please try again';
                //                 if(_error.errors[0]) _msg = "Error - "+ _error.errors[0];
                //                 MessageDisplayUtil.showMessageToast(_msg,
                //                 this.platform , this.toastCtl,3000, "bottom");
                //                 })
                //         } else {
                //             this.viewCtrl.dismiss({
                //                 created: true
                //             })
                //         }
                //     } else {

                //         this.viewCtrl.dismiss({
                //             created: true
                //         })
                //     }
                // }, (error)=>{
                //     let _error = error.json();
                //
                //     let _msg = 'Error reaching server at the moment. Please try again';
                //     if(_error.errors[0]) _msg = "Error - "+ _error.errors[0];
                //     MessageDisplayUtil.showMessageToast(_msg,
                //     this.platform , this.toastCtl,3000, "bottom");
                //     })
                // }
              }
            }
          },
          (error) => {
            let _error = error;

            let _msg;
            if (_error.status === 404)
              _msg =
                _error.status + ' - ' + _error.error + ' .' + _error.message;
            else if (_error.errors && _error.errors.length > 0)
              _msg = _error.errors[0];
            else _msg = 'Error connecting to server. Please try again.';
            MessageDisplayUtil.showErrorToast(
              _msg,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
        );
    } else {
      console.debug("updating program membership",  _playerId,
      _programId,
      _membershipNo,
      _validFrom,
      _validUntil)
      if(1) return;
      this.flightService
        .createPlayerDiscountCard(
          _playerId,
          _programId,
          _membershipNo,
          _validFrom,
          _validUntil
        )
        .subscribe(
          (data) => {
            if (data) {

              if (data.status === 200) {
                let _data = data.json();
                let _existing = false;

                if (this.data) {
                  this.data.filter((d) => {
                    if (d.id === _data.id) _existing = true;
                  });
                  let _msg = 'Successfully updated discount card';
                  MessageDisplayUtil.showErrorToast(
                    _msg,
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                  // return false;
                }
                if (_existing)
                  _msg =
                    'Successfully updated card #id : ' + _data.membershipNumber;
                else if (this.mode === 'edit')
                  _msg = 'Successfully updated the card';
                else _msg = 'Successfully added new card';
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                this.playerDiscountProgram = _data;
                if (this.temporaryImageURL)
                  this._uploadImage(this.temporaryImageURL);
                else if (!this.isCordova() && this.temporaryImageURL)
                  this._uploadImage(this.temporaryImageURL);

                if (!this.fromClub)
                  this.modalCtrl.dismiss({
                    created: true,
                  });
                // if(this.fromClub) {

                // this.flightService.applyForClubVerifyDiscountCard(_playerId, _programId, _clubId)
                // .subscribe((data)=>{
                //     if(data) {
                //
                //         if(this.fromClub) {
                //             this.flightService.approvePlayerDiscountCard(_playerId, _programId, _clubId)
                //             .subscribe((data)=>{
                //                 if(data) {
                //                     this.viewCtrl.dismiss({
                //                         created: true
                //                     })
                //                 } else {
                //                     this.viewCtrl.dismiss({
                //                         created: true
                //                     })
                //                 }
                //             }, (error)=>{
                //                 let _error = error.json();
                //
                //                 let _msg = 'Error reaching server at the moment. Please try again';
                //                 if(_error.errors[0]) _msg = "Error - "+ _error.errors[0];
                //                 MessageDisplayUtil.showMessageToast(_msg,
                //                 this.platform , this.toastCtl,3000, "bottom");
                //                 })
                //         } else {
                //             this.viewCtrl.dismiss({
                //                 created: true
                //             })
                //         }
                //     } else {

                //         this.viewCtrl.dismiss({
                //             created: true
                //         })
                //     }
                // }, (error)=>{
                //     let _error = error.json();
                //
                //     let _msg = 'Error reaching server at the moment. Please try again';
                //     if(_error.errors[0]) _msg = "Error - "+ _error.errors[0];
                //     MessageDisplayUtil.showMessageToast(_msg,
                //     this.platform , this.toastCtl,3000, "bottom");
                //     })
                // }
              }
            }
          },
          (error) => {
            let _error = error;
            let _msg;
            if (_error.status === 404)
              _msg =
                _error.status + ' - ' + _error.error + ' .' + _error.message;
            else if (_error.errors && _error.errors.length > 0)
              _msg = _error.errors[0];
            else _msg = 'Error connecting to server. Please try again.';
            MessageDisplayUtil.showErrorToast(
              _msg,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
        );
    }
  }

  checkCardApproved() {
    let _approved;
    _approved = this.pendingPDP;
    return _approved && _approved.length > 0;
  }
  onAddInsuranceCard() {
    // if(!this.selectedInsuranceCompany) {
    //     MessageDisplayUtil.showMessageToast('Please select Insurance Company',
    //     this.platform , this.toastCtl,3000, "bottom");
    //     return false;
    // }

    if (
      !this.insuranceName ||
      (this.insuranceName && this.insuranceName.length === 0)
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please enter policy name',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (
      !this.insuranceNo ||
      (this.insuranceNo && this.insuranceNo.length === 0)
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please enter policy number',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (this.insuranceValidFrom >= this.insuranceValidUntil) {
      MessageDisplayUtil.showMessageToast(
        'Please enter valid dates',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _playerId = this.player.playerId
      ? this.player.playerId
      : this.player.id; // | this.player.id;

    let _insuranceCompanyId = this.selectedInsuranceCompany;
    let _insuranceNo = this.insuranceNo;
    let _clubId = this.fromClub ? this.clubId : null;
    let _validFrom = moment(this.insuranceValidFrom).format('YYYY-MM-DD');
    let _validUntil = moment(this.insuranceValidUntil).format('YYYY-MM-DD');
    let _msg;
    let _params = {
      name: this.insuranceName,
      insuranceNo: this.insuranceNo,
      startDate: _validFrom,
      endDate: _validUntil,
      insuranceCompanyName:
        this.selectedInsuranceCompany && this.selectedInsuranceCompany.name
          ? this.selectedInsuranceCompany.name
          : '',
      insuranceCompanyId:
        this.selectedInsuranceCompany && this.selectedInsuranceCompany.id
          ? this.selectedInsuranceCompany.id
          : '',
      applicableIn: this.insuranceApplicableIn,
      description: this.selectedInsuranceCompany
        ? this.selectedInsuranceCompany.description
        : null,
      playerId: _playerId,
      // insuranceDocument: this.temporaryImageURL?this.temporaryImageURL:null,
    };

    // if(this.temporaryImageURL) _params['insuranceDocument'] = this.temporaryImageURL;
    if (this.temporaryImageURL)
      this._uploadImage(this.temporaryImageURL, _params);
    else {
      this.flightService.addPlayerInsurance(_playerId, _params).subscribe(
        (data) => {

          if (data) {
            if (data && data.success && data.status === 200) {
              let _msg = 'Succesfully added Insurance card';
              MessageDisplayUtil.showMessageToast(
                _msg,
                this.platform,
                this.toastCtl,
                3000,
                'bottom'
              );
              this.modalCtrl.dismiss({
                created: true,
              });
            } else {
              let _msg = 'Succesfully added Insurance card';
              MessageDisplayUtil.showMessageToast(
                _msg,
                this.platform,
                this.toastCtl,
                3000,
                'bottom'
              );
              this.modalCtrl.dismiss({
                created: true,
              });
            }
          }
        },
        (error) => {
          let _error = error;

          let _msg = _error.errorMessage;
          MessageDisplayUtil.showMessageToast(
            _msg,
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          return false;
        }
      );
    }
  }
  async onSearchInsuranceCompany() {
    let _type = 'insurance';
    let modal = await this.modalCtrl.create({
      component: SearchDiscountCompanyPage,
      componentProps: {
        headerTitle: 'Select Insurance Company',
        partnerType: _type,
      },
    });
    modal.onDidDismiss().then((data: any) => {

      if (data && data?.data?.selected) {
        this.selectedInsuranceCompany = data?.data?.discCompany;
        this.insuranceApplicableIn = data?.data?.discCompany?.country
          ? data?.data?.discCompany?.country?.id
          : '';
      }
    });
    modal.present();
  }
  onUpdateInsuranceCard() {
    // if(!this.selectedInsuranceCompany) {
    //     MessageDisplayUtil.showMessageToast('Please select Insurance Company',
    //     this.platform , this.toastCtl,3000, "bottom");
    //     return false;
    // }
    if (
      !this.insuranceName ||
      (this.insuranceName && this.insuranceName.length === 0)
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please enter policy name',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (
      !this.insuranceNo ||
      (this.insuranceNo && this.insuranceNo.length === 0)
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please enter policy number',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    if (this.insuranceValidFrom >= this.insuranceValidUntil) {
      MessageDisplayUtil.showMessageToast(
        'Please enter valid dates',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    let _playerId = this.player.playerId
      ? this.player.playerId
      : this.player.id; // | this.player.id;

    let _insuranceCompanyId = this.selectedInsuranceCompany;
    let _insuranceNo = this.insuranceNo;
    let _insuranceId = this.playerInsurance.id;
    let _clubId = this.fromClub ? this.clubId : null;
    let _validFrom = moment(this.insuranceValidFrom).format('YYYY-MM-DD');
    let _validUntil = moment(this.insuranceValidUntil).format('YYYY-MM-DD');
    let _msg;
    let _params = {
      name: this.insuranceName,
      insuranceNo: this.insuranceNo,
      startDate: moment(this.insuranceValidFrom).format('YYYY-MM-DD'),
      endDate: moment(this.insuranceValidUntil).format('YYYY-MM-DD'),
      // insuranceCompanyName: this.selectedInsuranceCompany?this.selectedInsuranceCompany.name:null,
      insuranceCompanyName:
        this.selectedInsuranceCompany && this.selectedInsuranceCompany.name
          ? this.selectedInsuranceCompany.name
          : '',
      insuranceCompanyId: this.selectedInsuranceCompany
        ? this.selectedInsuranceCompany.id
        : null,
      applicableIn: this.insuranceApplicableIn,
      // this.insuranceApplicableIn&&this.insuranceApplicableIn.length>0?this.insuranceApplicableIn.join(','):null, //this.selectedInsuranceCompany.country.id,
      description: this.selectedInsuranceCompany
        ? this.selectedInsuranceCompany.description
        : null,
      playerId: _playerId,
      insuranceId: this.playerInsurance.id,
      // insuranceDocument: this.temporaryImageURL?this.temporaryImageURL:null,
    };
    // if(this.temporaryImageURL) _params['insuranceDocument'] = this.temporaryImageURL;

    // this._uploadImage()

    // let _params = new FormData();
    // _params.append('name',this.selectedInsuranceCompany.name)
    // _params.append('insuranceNo',this.insuranceNo)
    // _params.append('startDate',this.insuranceValidFrom)
    // _params.append('endDate',this.insuranceValidUntil)
    //
    if (this.temporaryImageURL) {

      this._uploadImage(this.temporaryImageURL, _params);
    }
    else {

      this.flightService
        .updatePlayerInsurance(_playerId, _insuranceId, _params)
        .subscribe(
          (data) => {

            if (data) {
              if (data && data.success && data.status === 200) {
                let _msg = 'Succesfully updated Insurance card';
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                this.modalCtrl.dismiss({
                  created: true,
                });
              } else {
                let _msg = 'Succesfully updated Insurance card';
                MessageDisplayUtil.showMessageToast(
                  _msg,
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
                this.modalCtrl.dismiss({
                  created: true,
                });
              }
            }
          },
          (error) => {
            let _error = error;
            let _msg = _error.errorMessage;
            MessageDisplayUtil.showMessageToast(
              _msg,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
        );
    }
  }
  getInsuranceCompanyName() {
    return this.selectedInsuranceCompany && this.selectedInsuranceCompany.name
      ? this.selectedInsuranceCompany.name
      : 'Select Insurance Company (tap here)';
  }
  async takePhotoFromGallery(event, mode?: string) {
    // if (event) {
    //   const fileObject = event.target.files[0];
    // }

    this.selectedFiles = event.target.files[0];
    // const file = (event.target as HTMLInputElement).files;
    //

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      const images = [];
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        reader.onload = (event: any) => {
          // Push Base64 string
          images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);

      }
      this.temporaryImageURL = event.target.files[0].name;

      this.previewImage = images;
      if (this.selectedFiles && mode === 'update')
        this._uploadImage(this.temporaryImageURL);
    }
  }
  emailIsValid(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email); //latest Aug 2022
  }
  onAddPlayerDiscountCard() {
    if (this.selectOrNewPlayer === 'new') {
      if (
        !this.addPlayerDetails.email ||
        !this.addPlayerDetails.playerName ||
        this.addPlayerDetails.email.length === 0 ||
        this.addPlayerDetails.playerName.length === 0
      ) {
        MessageDisplayUtil.showErrorToast(
          'Please fill-in Player Name and Email Address',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      //
      if (!this.emailIsValid(this.addPlayerDetails.email)) {
        MessageDisplayUtil.showErrorToast(
          'Please use valid Email Address',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      this.createContact(this.addPlayerDetails, true)
        .then((result: any) => {
          if (result && result.status === 'success') {
            this.player = result.data;
            this.player.playerId = result.data.id;
            this.onAddDiscountCard();
            // this.nav.push(PlayerVoucherModal, {
            //     type: 'discount',
            //     player: result.data,
            //     forBooking: false,
            //     fromClub: false,
            //     who: 'player',
            //     showPlayerCard: true,
            //     disableAll: 'yes',
            //     partnerInfo: this.isNGA?null:this.partnerInfo,
            //     fromPartner: this.isNGA?null:this.partnerInfo
            // })
          }
        })
        .catch(async (error: any) => {
          if (error && error.status === 'failed') {
            let _error = error.error;
            let _msg = _error.errorMessage;
            MessageDisplayUtil.showMessageToast(
              _msg,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );

            let prompt = await this.alertCtrl.create({
              header: 'Mandatory',
              message: _msg,
              // inputs: [{
              //     name: 'title',
              //     placeholder: 'Group Name'
              // }, ],
              buttons: [
                {
                  text: 'Ok',
                  handler: (data) => {
                    prompt.dismiss();
                  },
                },
              ],
            });
            prompt.present();
            return false;
          }
        });
    } else if (this.selectOrNewPlayer === 'select') {
      //! existing player
      if (!this.player) {
        MessageDisplayUtil.showErrorToast(
          'Please select a player',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      this.onAddDiscountCard();
    }
  }
  createContact(playerDetails: any, addClubMember?: boolean) {
    return new Promise(async (resolve, reject) => {
      let loader = await this.loadingCtrl.create({
        showBackdrop: false,
        duration: 10000,
        message: 'Registering player...',
      });
      //Validate the entries


      let _firstName;
      let _lastName;
      let _gender;
      let _phone;
      let _email;
      let _handicap;
      let _teeOffFrom;
      let _countryId;
      let _clubId;
      //

      if (playerDetails) {
        //
        _firstName = this.addPlayerDetails.playerName;
        _lastName = ' ';
        _gender = this.addPlayerDetails.gender;
        _phone = this.addPlayerDetails.phoneNumber;
        _email = this.addPlayerDetails.email;
        _handicap = _gender === 'M' ? 24 : 36;
        _teeOffFrom = _gender === 'M' ? 'Blue' : 'Red';
        _countryId = 'MYS'; //this.teeSlotNew?this.clubInfo.countryId:this.bookingSlot.clubData.address.countryData.id;

        this.playerService
          .addPlayer(
            _firstName,
            _lastName,
            _gender,
            _email,
            _phone,
            _handicap,
            _teeOffFrom,
            _countryId
          )
          .subscribe(
            (player: PlayerData) => {

              if (player) {
                if (loader) loader.dismiss();
                resolve({
                  status: 'success',
                  data: player,
                });
              }
            },
            (error) => {
              if (loader) loader.dismiss();
              reject({
                status: 'failed',
                error: error,
              });

              let _error = error;
              // let msg       = MessageDisplayUtil.getErrorMessage(error, "Error creating contact");
              // let msg       = MessageDisplayUtil.getErrorMessage(error, _error.errorMessage);
              // MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
            },
            () => { }
          );
      } else {
        resolve({
          status: 'failed',
        });
      }
      // return false;
    });
  }
  async onSelectFilterPlayer() {
    let _membersOnly: boolean = false;
    let _playerWallet: boolean = false;
    let _playerModal = await this.modalCtrl.create({
      component: AddPlayerListPage,
      componentProps: {
        fromClub: true,
        openedModal: true,
        clubId: null,
        // membershipType: 'P',
        membersOnly: false,
        initTab: null,
        // playerWallet: _playerWallet,
        noNewPlayer: true,
        fromPartner: true,
        // currencySymbol: this.currencySymbol,
      },
    });

    _playerModal.onDidDismiss().then((data: any) => {

      if (data?.data) {
        this.player = data.data.item;
      } else {
      }
    });
    _playerModal.present();
  }
  clearFilteredPlayer() {
    this.player = null;
  }

  triggerFileInput() {
    document.getElementById('file-input').click();
  }

  deleteImage(){
   this.selectedFiles = null;
   this.temporaryImageURL = null;
   if(this.playerDiscountProgram?.document){
      this.playerDiscountProgram.document = null;
   }
  }
}
